module.exports = __webpack_public_path__ + "img/mobile1.3861d442.png";